import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SelectSimilar = (props) => (
  <SvgIcon
    width="20.174"
    height="16.137"
    viewBox="0 0 20.174 16.137"
    {...props}
  >
    <g transform="translate(-357 -9)">
      <g transform="translate(357 9)">
        <rect width="12" height="12" />
        <rect x="1" y="1" width="10" height="10" />
      </g>
      <g transform="translate(361 13)">
        <rect width="12" height="12" />
        <rect x="1" y="1" width="10" height="10" />
      </g>
    </g>
  </SvgIcon>
);
export default SelectSimilar;



// WEBPACK FOOTER //
// ./src/common/icons/SelectSimilar/index.tsx